import { useEffect, useState } from "react";
import { Banner, Text } from "@shopify/polaris";
import { onReauthRequired, pendingReauthUrl } from "../api";

// Shown when ShipPromise can no longer read the shop's stored Shopify credentials.
// Nothing that talks to Shopify works until the app is reinstalled, so this sits
// in the app shell above every page rather than on whichever screen happened to
// make the failing request.
export default function ReconnectBanner(): JSX.Element | null {
  const [url, setUrl] = useState<string | null>(pendingReauthUrl());

  // The listener fires with a string when a request throws reauth_required and
  // with null when a subsequent request confirms the shop is installed again,
  // so this hides the banner as soon as the fix takes effect.
  useEffect(() => onReauthRequired(setUrl), []);

  if (!url) return null;

  return (
    <Banner
      tone="critical"
      title="ShipPromise needs to be reconnected"
      action={{
        content: "Reconnect ShipPromise",
        // Not `url:` — that renders an anchor App Bridge routes inside the
        // iframe, and Shopify's OAuth screen refuses to render in one. Opening
        // on _top is what takes the merchant out of the embedded frame so the
        // install flow can run.
        onAction: () => window.open(url, "_top"),
      }}
    >
      <Text as="p">
        ShipPromise's access to this shop has stopped working, so labels are not being bought or printed.
        Reconnecting takes a few seconds and keeps your rules, settings, connected accounts and print
        history.
      </Text>
    </Banner>
  );
}
